module.exports = __webpack_public_path__ + "img/thToEn.3f436d9b.png";